/**
 * Loop over all items and find the (first) selected one
 */
export var getValueFromItems = function (items) {
    var selectedItem = items.find(function (item) { return (item.optState === 'selected'); });
    return (selectedItem) ? selectedItem.stdOptionValue : undefined;
};
